import React, { useCallback, useEffect, useContext, useRef, } from 'react';
import { mergeProps } from '@react-aria/utils';
import { PopoverContainer } from './select.styles.js';
import { SelectContext } from './use-select-state.js';
export const SelectPopoverContainerComponent = ({ children, }) => {
    const { state, props } = useContext(SelectContext).selectState;
    const { selectionMode, isInModal, onConfirmSelection, onOpen } = props;
    const { selectedItems, overlayTriggerAria, popoverProps, buttonState, buttonRef, setCachedSelectedItems, setUncontrolledFilterValue, } = state;
    const isOpenedRef = useRef();
    const onClose = useCallback(() => {
        if (!isOpenedRef.current) {
            return;
        }
        setCachedSelectedItems(selectedItems);
        if (selectionMode === 'multiple') {
            props.onConfirmSelection?.(selectedItems);
            props.onClose?.(selectedItems);
        }
        else {
            props.onConfirmSelection?.(selectedItems[0]);
            props.onClose?.(selectedItems[0]);
        }
        setUncontrolledFilterValue('');
        buttonState.close();
        isOpenedRef.current = false;
    }, [selectedItems, buttonState.close, onConfirmSelection]);
    useEffect(() => {
        if (buttonState.isOpen) {
            onOpen?.();
        }
        else {
            onClose();
        }
        isOpenedRef.current = buttonState.isOpen;
    }, [buttonState.isOpen]);
    return (React.createElement(PopoverContainer, { ...mergeProps(overlayTriggerAria.overlayProps, popoverProps), isOpen: buttonState.isOpen, targetRef: buttonRef, onClose: onClose, isInModal: isInModal },
        React.createElement("div", { onMouseDown: (event) => {
                event?.preventDefault();
                event?.stopPropagation();
            } }, children)));
};
//# sourceMappingURL=select-popover-container.component.js.map